export default "__VITE_ASSET__50fff3b4__"